import React from "react";
import Slider from "react-slick";
import bannerImage from "../../assets/banner.jpg";

export default function BannerSlider() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  return (
    <Slider {...settings}>
      <div className="w-full slide">
        <img src={bannerImage} className="w-full md:h-[60vh] h-auto object-cover" alt="banner" />
      </div>
      <div className="w-full slide">
        <img src={bannerImage} className="w-full md:h-[60vh] h-auto object-cover" alt="banner" />
      </div>
      <div className="w-full slide">
        <img src={bannerImage} className="w-full md:h-[60vh] h-auto object-cover" alt="banner" />
      </div>
    </Slider>
  );
}
